import CorporateLogo from '@/Components/CorporateLogo.jsx';
import {usePage} from '@inertiajs/react';
import {Box, styled} from '@mui/material';
import {memo, useEffect, useRef, useState} from 'react';

const HeaderLogo = styled(CorporateLogo)({
    objectFit: 'contain',
    width: 'auto',
    height: 36,
    objectPosition: 'center',
    flex: 0,
});

const Header = ({children}) => {
    const [isVisible, setIsVisible] = useState(true);
    const lastScrollY = useRef(0);
    const {layout} = usePage().props;
    const hideLayout = layout && layout === '0';

    const handleScroll = ({target}) => {
        const current_scroll_y = target.scrollTop;

        if (current_scroll_y > 100 && current_scroll_y > lastScrollY.current) {
            setIsVisible(false);
        } else {
            setIsVisible(true);
        }

        lastScrollY.current = current_scroll_y;
    };

    useEffect(() => {
        const main = document.querySelector('#content');
        if (!main) return;
        main.addEventListener('scroll', handleScroll);
        return () => {
            main.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Box
            component="header"
            role="banner"
            id="header"
            className="gs18-Header gs18-Header--MinInteraction gs18-Header--NoSearch gs18-Header--withme"
            sx={{zIndex: 3}}
        >
            <Box className="gs18-Header__Inner" sx={{'@media (max-width: 1380px)': {pl: 2}}}>
                {!hideLayout && <HeaderLogo />}
                {children}
            </Box>
        </Box>
    );
};

export default memo(Header);
